import React, { ReactNode, useCallback, useState } from 'react'
import { BreadcrumbContext, BreadcrumbItem, BreadcrumbTrailing } from './BreadcrumbContext'

export const BreadcrumbProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
	const [breadcrumbs, setBreadcrumbs] = useState<BreadcrumbItem[]>([])
	const [trailing, setTrailingState] = useState<BreadcrumbTrailing | null>(null)

	// A component is a function, and React treats a bare function passed to a
	// state setter as an updater and calls it — so always store it via a thunk.
	const setTrailing = useCallback(
		(component: BreadcrumbTrailing | null) => setTrailingState(() => component),
		[],
	)

	return (
		<BreadcrumbContext.Provider value={{ breadcrumbs, setBreadcrumbs, trailing, setTrailing }}>
			{children}
		</BreadcrumbContext.Provider>
	)
}
